import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { PetlService } from '../../../services/petl.service';
import { PetlBaseComponent } from '../petl-base.component';
var PetlPromotedComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PetlPromotedComponent, _super);
    function PetlPromotedComponent(_vcr, petlService, cdr) {
        var _this = _super.call(this, _vcr, petlService, cdr) || this;
        _this.petlService = petlService;
        _this.cdr = cdr;
        _this.showIssues = false;
        return _this;
    }
    Object.defineProperty(PetlPromotedComponent.prototype, "errorCount", {
        get: function () {
            var e_1, _a;
            var promoteReport = this.petlService.project.promoteReport;
            var errorCount = 0;
            if (promoteReport) {
                try {
                    for (var _b = tslib_1.__values(promoteReport.scenarios), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var scenario = _c.value;
                        errorCount = errorCount + scenario.errors.length;
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            return errorCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlPromotedComponent.prototype, "projectHasPromoteResults", {
        get: function () {
            return this.project && (this.project.lineCount || this.project.pointCount || this.project.promoteReport);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlPromotedComponent.prototype, "project", {
        get: function () {
            return this.service.project;
        },
        enumerable: true,
        configurable: true
    });
    PetlPromotedComponent.prototype.toggleShowIssues = function () {
        this.showIssues = !this.showIssues;
    };
    PetlPromotedComponent.prototype.startOver = function () {
        this.petlService.startOver();
    };
    return PetlPromotedComponent;
}(PetlBaseComponent));
export { PetlPromotedComponent };
